const initailState = {
  activeMenu: false,
  user: null,
  todos: [],
};

export default initailState;
